export default __webpack_public_path__ + "static/media/carousel-simplenight.0e0f8526.jpg";